import { Box, Skeleton, Tooltip } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import { engagmentLevel, engagmentLevels } from './EngagementMeter';
import { formatNumberToStringMonthWithoutYear } from '../../utils/dateUtils';
import i18n from '../../i18n';

export interface IOverallEngagementMeterProps {
  engageData: {
    date: string;
    engagementLevel: string;
  }[];
  size?: number;
  clientActivityProgressLoading?: boolean;
}

const OverallEngagementMeter = ({
  engageData,
  size = 16,
  clientActivityProgressLoading,
}: IOverallEngagementMeterProps) => (
  <Box display="flex" gap="12px" justifyContent="space-between" alignItems="center" width="100%">
    {clientActivityProgressLoading
      ? [...Array(20)].map((_count) => (
          <Skeleton key={uuidv4()} variant="rounded" width={42} height={42} animation="wave" />
        ))
      : engageData.map((item) => (
          <Tooltip
            key={item.date}
            title={`${formatNumberToStringMonthWithoutYear(item.date)} - ${i18n.t(
              engagmentLevels[item.engagementLevel as keyof typeof engagmentLevels]
            )}`}
            placement="top"
            arrow
            componentsProps={{
              tooltip: {
                sx: {
                  bgcolor: 'primary.main',
                  borderRadius: '5px',
                  padding: '8px 12px',
                },
              },
              arrow: {
                sx: {
                  '&:before': {
                    bgcolor: 'primary.main',
                  },
                },
              },
            }}
          >
            <img
              key={item.date}
              src={engagmentLevel[item.engagementLevel as keyof typeof engagmentLevel]}
              alt={item.date}
              style={{ height: size, width: size }}
            />
          </Tooltip>
        ))}
  </Box>
);

export default OverallEngagementMeter;
